import * as actionTypes from './actionsTypes';

export const setUserNotification = (notificationData) => {
  return {
    type: actionTypes.SET_NOTIFICATION,
    data: notificationData,
  };
};

export const setJSPMStatus = (jspmStatus) => {
  return {
    type: actionTypes.SET_JSPMSTATUS,
    data: jspmStatus,
  };
};

export const setPrinterConfiguration = (printerConfiguration) => {
  return {
    type: actionTypes.SET_PRINTERCONFIGURATION,
    data: printerConfiguration,
  };
};

export const setAvailablePrinter = (printerList) => {
  return {
    type: actionTypes.SET_AVAILABLEPRINTERS,
    data: printerList,
  };
};

export const setGenralConfiguration = (genConfig) => {
  return {
    type: actionTypes.SET_COMMONCONFIGURATION,
    data: genConfig,
  };
};

export const setAppSnackBarData = (payload) => {
  return {
    type: actionTypes.SET_APPSNACKBAR,
    data: payload,
  };
};

export const resetAppSnackBarData = (payload) => {
  return {
    type: actionTypes.RESET_APPSNACKBAR,
    data: payload,
  };
};

export const setBottomAlert = (payload) => {
  return {
    type: actionTypes.SET_BOTTOM_ALERT,
    data: payload,
  };
};

export const resetBottomAlert = (payload) => {
  return {
    type: actionTypes.RESET_BOTTOM_ALERT,
    data: payload,
  };
};

export const setActiveTab = (tab) => {
  return {
    type: actionTypes.SETACTIVETAB,
    data: tab,
  };
};

export const setReturnReferenceCount = (count) => {
  return {
    type: actionTypes.SET_RETURN_REFERENCE_COUNT,
    data: count,
  };
};

export const setIsReturnReferenceUpdated = (isUpdated) => {
  return {
    type: actionTypes.SET_IS_RETURN_REFERENCE_UPDATED,
    data: isUpdated
  }
};

export const resetReturnReferenceParams = () => {
  return {
    type: actionTypes.RESET_RETURN_REFERENCE_VALUES,
    data: null
  }
}

export const setAllAvailableProducts = (products) => {
  return {
    type: actionTypes.SET_ALL_PRODUCTS,
    data: products
  }
}

export const setDhlIossNumber = (dhlIossNumber) => {
  return {
    type:actionTypes.SET_DHL_IOSS_NUMBER,
    data:dhlIossNumber,
  }
}

export const setSortOrderState = (order) => {
  return {
    type:actionTypes.SET_SORT_ORDER_STATE,
    data:order,
  }
}

export const setAutoReloadProcessOrders = (autoReloadFlag) => {
  return {
    type: actionTypes.SET_AUTORELOAD_PROCESSORDERS,
    data: autoReloadFlag,
  };
};

// Action creator for setting the service point dimensions weight
export const setServicePointWeight = (weight) => {
  return {
    type: actionTypes.SET_SERVICE_POINT_WEIGHT,
    data: weight,
  };
};

// Action creator for setting the service point dimensions weight
export const setMaximumWeightPerParcelWithFullCustoms = (maxWeightFullcustoms) => {
  return {
    type: actionTypes.SET_MAX_WEIGHT_PER_PARCEL_WITH_FULL_CUSTOMS,
    data: maxWeightFullcustoms,
  };
};

// Action creator for setting the service point collection details
export const setServicePointCollectionData = (data) => {
  return {
    type: actionTypes.SET_SERVICE_POINT_COLLECTION_DATA,
    data: data,
  };
};